<script setup lang="ts">
import { storeToRefs } from 'pinia';

import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import LargeBodyText from '@/components/base/typography/LargeBodyText.vue';
import UnstyledButton from '@/components/base/UnstyledButton.vue';
import { useAutoDelivery } from '@/stores/autoDelivery';

defineEmits<{ 'faq-click': [] }>();

const { autoDeliveryChannel } = storeToRefs(useAutoDelivery());
</script>

<template>
  <div>
    <BaseBodyText>Here is what you get with your subscription:</BaseBodyText>
    <div
      class="flex flex-col mt-3 border-b border-solid divide-y md:mt-8 md:border-y border-neutral-300 divide-solid divide-neutral-300"
    >
      <div class="flex gap-4 py-3">
        <img
          alt=""
          class="self-center flex-shrink-0 object-contain w-14 h-14 md:w-20 md:h-20"
          src="@/assets/pdp/auto-delivery-modal/nuts.jpg"
        />
        <div class="self-center">
          <LargeBodyText class="font-bold text-black">
            Enjoy {{ autoDeliveryChannel.discount }}% off on your first and all future orders
          </LargeBodyText>
          <BaseBodyText class="mt-0.5 text-neutral-500">
            Shop &amp; save on thousands of snacks.
          </BaseBodyText>
        </div>
      </div>
      <div class="flex gap-4 py-3">
        <img
          alt=""
          class="self-center flex-shrink-0 object-contain w-14 h-14 md:w-20 md:h-20"
          src="@/assets/pdp/auto-delivery-modal/package.jpg"
        />
        <div class="self-center">
          <LargeBodyText class="font-bold text-black">
            Change or cancel your subscription whenever
          </LargeBodyText>
          <BaseBodyText class="mt-0.5 text-neutral-500">
            No fixed plans &ndash; skip, postpone and cancel at any time, free of charge.
          </BaseBodyText>
        </div>
      </div>
      <div class="flex gap-4 py-3">
        <img
          alt=""
          class="self-center flex-shrink-0 object-contain w-14 h-14 md:w-20 md:h-20"
          src="@/assets/pdp/auto-delivery-modal/parachute.jpg"
        />
        <div class="self-center">
          <LargeBodyText class="font-bold text-black">
            Get your favorites delivered on repeat
          </LargeBodyText>
          <BaseBodyText class="mt-0.5 text-neutral-500">
            Set a delivery schedule that works best for you.
          </BaseBodyText>
        </div>
      </div>
    </div>
    <UnstyledButton
      class="py-2 mt-4"
      data-test="auto-delivery-read-faq-button"
      @click="$emit('faq-click')"
    >
      <BaseBodyText class="font-semibold underline text-cyan-700">
        Read our Auto-Delivery FAQs
      </BaseBodyText>
    </UnstyledButton>
  </div>
</template>
